/**
 * Convert Firestore polygon ({lng,lat} objects) to GeoJSON coordinate array ([lng,lat] pairs).
 */
export function polygonToCoords(polygon) {
  if (!polygon || !polygon.length) return [];
  // Already in [lng, lat] array format
  if (Array.isArray(polygon[0])) return polygon;
  // Convert from {lng, lat} object format
  return polygon.map((p) => [p.lng, p.lat]);
}

/**
 * Convert GeoJSON coordinate array ([lng,lat] pairs) to Firestore-safe objects ({lng,lat}).
 */
export function coordsToPolygon(coords) {
  if (!coords || !coords.length) return [];
  return coords.map(([lng, lat]) => ({ lng, lat }));
}

/**
 * Ray-casting point-in-polygon algorithm.
 * @param {number} lat - Latitude of the point
 * @param {number} lng - Longitude of the point
 * @param {Array} polygon - Array of {lng, lat} objects or [lng, lat] pairs
 * @returns {boolean}
 */
export function pointInPolygon(lat, lng, polygon) {
  const coords = polygonToCoords(polygon);
  let inside = false;
  for (let i = 0, j = coords.length - 1; i < coords.length; j = i++) {
    const xi = coords[i][1], yi = coords[i][0];
    const xj = coords[j][1], yj = coords[j][0];
    const intersect = ((yi > lng) !== (yj > lng)) &&
      (lat < (xj - xi) * (lng - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

/**
 * Detect which region a point falls within.
 * @param {number} lat
 * @param {number} lng
 * @param {Array<{name: string, polygon: Array}>} regions
 * @returns {object|null} The first matching region object, or null
 */
export function detectRegion(lat, lng, regions) {
  if (!regions || !regions.length) return null;
  for (const region of regions) {
    if (region.polygon && pointInPolygon(lat, lng, region.polygon)) {
      return region;
    }
  }
  return null;
}
